<template>
  <section class="edit-container">
    <h2>Edit Credit Transfer Request</h2>
    <div class="abs-top-right">
      <v-button @click="$emit('cancel')">Cancel</v-button>
      <v-button
        type="primary"
        @click="handlerSave">Save</v-button>
    </div>
    <div class="form-container">
      <div class="form-item">
        <span>Transfer Amount</span>
        <v-input v-model="formData.money" />
      </div>
      <div class="form-item">
        <span>Bank Account Holder</span>
        <v-input v-model="formData.card_holder" />
      </div>
      <div class="form-item">
        <span>Bank</span>
        <v-select
          v-model="formData.bank_code"
          valueKey="bank_code"
          labelKey="bank_name"
          :list="bankList" />
      </div>
      <div class="form-item">
        <span>Bank Account No.</span>
        <v-input v-model="formData.card_number" />
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import { changeTicketCategory, editTicketCredit } from '@/api/ticket'
import { mapState } from 'vuex'
export default {
  name: 'EditCreditTransfer',
  mixins: [MixinOptions],
  props: {
    ticketId: [Number, String],
    changeCategoryType: {
      type: [String, Number],
      default: ''
    },
    customerId: Number,
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        money: '',
        card_holder: '',
        bank_code: '',
        card_number: ''
      },
    }
  },
  computed:{
    ...mapState('common', ['bankList']),
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler(val) {
        this.formData = Object.assign(this.formData, JSON.parse(JSON.stringify(val)))
      }
    }
  },
  methods: {
    handlerSave() {
      if(this.changeCategoryType === '') {
        this.network().editTicketCredit()
      } else {
        this.network().changeTicketCategory()
      }
    },
    network() {
      return {
        changeTicketCategory: async () => {
          const { data } = await changeTicketCategory({
            ticket_id: this.ticketId,
            type: 4,
            customer_id: this.customerId,
            ...this.formData
          })
          this.$emit('save')
        },
        editTicketCredit: async () => {
          const { data } = await editTicketCredit({
            ticket_id: this.ticketId,
            customer_id: this.customerId,
            ...this.formData
          })
          this.$emit('save')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-container {
    position: relative;
    padding: 15px;
    .abs-top-right {
        top: 20px;
        right: 15px;
    }
    .form-container {
        width: 370px;
    }
}
</style>